export const checkIfFilesAreAttachedForIssues = (listOfSelectedFiles) => {
  const attachedIssues = Object.values(listOfSelectedFiles).filter(
    (issue) => issue.resourceType == "RESOURCE_TYPE_ISSUE",
  );
  const allFilesAttached = Object.keys(listOfSelectedFiles);

  const filteredIssues = [];

  attachedIssues.forEach((issue) => {
    if (!allFilesAttached.includes(issue.fileId)) {
      filteredIssues.push(issue);
    }
  });
  return filteredIssues;
};
